import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import { findIndex, remove, concat, filter } from 'lodash';
import TagBtn from '../common/button/TagBtn';
import { useSelector, useDispatch } from 'react-redux';
import { setStDelFilterAction, setStFilterChangeAction } from '../../modules/st/stContentsModule';

import {isMobileOnly} from 'react-device-detect';


const SpaceFilterListBlock = styled.div`
  .tf-list {
    display: flex;
    flex-wrap:wrap;
  }
`;

const SpaceFilterList = ({ filterTitle, filterList, reset }) => {

    const dispatch = useDispatch();

    const [title, setTitle] = useState(filterTitle);
    const [filterIds, setFilterIds] = useState([]);
    const [delFilters, setDelFilters] = useState([]);

    const { stDelFilterInfo } = useSelector(
        ({ stContentsReducer }) => ({
            stDelFilterInfo: stContentsReducer.stDelFilterInfo,
        })
    );

    useEffect(() => {
        // console.log(" filterList : " + JSON.stringify(filterList));
        setTitle(filterTitle);
        setFilterIds(filterList);

        if (filterList !== null) {
             //console.log(" stDelFilterInfo : " + JSON.stringify(stDelFilterInfo));
            let deltarget = filter(stDelFilterInfo, (curid) => {
                 //console.log(curid + " : " + Math.floor(curid / 100));
                return Math.floor(curid / 100) === filterList[0].filter1_id;
            })
            setDelFilters(deltarget);
             //console.log(filterList[0].filter1_id + " : deltarget : " + deltarget)
        } else {
            setDelFilters([]);
        }

    }, [filterTitle, filterList, reset])


    const handleFilterClick = (id) => {
        let idx = findIndex(delFilters, (curid) => { return curid === id });
        let deltarget = null;
        let stDelFilter = null;

        //전체 상태
        if(checkAll()){
            stDelFilter = stDelFilterInfo;
            filterIds.map((item) => {
                let filtervalue = item.filter1_id * 100 + item.filter2_id * 1;
                deltarget = concat(deltarget, filtervalue)
                stDelFilter = concat(stDelFilter, filtervalue);
            })
            deltarget = filter(deltarget, (curid) => { return curid !== id });
            stDelFilter = filter(stDelFilter, (curid) => { return curid !== id });
        }
        else {
            // 없으면 추가
            if (idx === -1) {
                // 1 개만 남아 있을 경우는 삭제 불가
                //if (delFilters.length === filterList.length - 1) return;

                deltarget = concat(delFilters, id)
                stDelFilter = concat(stDelFilterInfo, id);
            } else { // 있으면 삭제
                deltarget = filter(delFilters, (curid) => { return curid !== id });
                stDelFilter = filter(stDelFilterInfo, (curid) => { return curid !== id });
            }
        }

        dispatch(setStFilterChangeAction(true));
        setDelFilters(deltarget);
        dispatch(setStDelFilterAction(stDelFilter))
    }

    // 전체 선택 상태인지 확인
    const checkAll = () => {
        return delFilters.length === 0;
    }

    const checkActive = (id) => {
        if(checkAll()){
            return false;
        }

        let idx = findIndex(delFilters, (curid) => { return curid === id });
        return idx === -1;
    }

    const handleAllCheckClick = () => {
        setDelFilters([]);
        let deltarget = filter(stDelFilterInfo, (curid) => {
            return Math.floor(curid / 100) !== filterIds[0].filter1_id;
        })
        dispatch(setStFilterChangeAction(true));
        dispatch(setStDelFilterAction(deltarget))
    }

    return (
        <SpaceFilterListBlock>
            <div className="tf-item clearfix">
                <span className="tf-title">{title}</span>
                <ul className="tf-list clearfix">
                    <li>
                        <TagBtn
                            active={checkAll()}
                            float='left'
                            onClick={handleAllCheckClick}
                            onDelClick={handleAllCheckClick}
                            text='전체' isSmall={true} value={false}
                            noDelBtn={checkAll() ? "true" : "false"}
                        />
                    </li>
                    {
                        (filterIds === null) ? (<li> loading ... </li>) :
                            (
                                filterIds.map((item) => {
                                    let filtervalue = item.filter1_id * 100 + item.filter2_id * 1;
                                    // console.log("item : " + JSON.stringify(item))
                                    return (
                                        <li key={filtervalue} style={{ marginLeft: isMobileOnly?'5px':'40px'}}>
                                            <TagBtn
                                                active={checkActive(filtervalue)}
                                                float='left'
                                                onClick={() => { handleFilterClick(filtervalue) }}
                                                onDelClick={() => { handleFilterClick(filtervalue) }}
                                                text={item.filter_name}
                                                isSmall={true}
                                                value={filtervalue}
                                            />
                                        </li>
                                    );
                                })
                            )
                    }

                </ul>
            </div>
        </SpaceFilterListBlock>
    );
};

export default SpaceFilterList;
